import { render, staticRenderFns } from "./GroupDashboardDialog.vue?vue&type=template&id=0b4f3d0d&"
import script from "./GroupDashboardDialog.vue?vue&type=script&lang=js&"
export * from "./GroupDashboardDialog.vue?vue&type=script&lang=js&"
import style0 from "./GroupDashboardDialog.vue?vue&type=style&index=0&id=0b4f3d0d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports